function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.516
}, /*#__PURE__*/React.createElement("g", {
  fill: "#53585C"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.786 2.223c4.127 0 8.086 1.64 11.004 4.558 2.919 2.919 4.558 6.877 4.558 11.005 0 8.595-6.967 15.562-15.562 15.562-8.595 0-15.563-6.967-15.563-15.562 0-8.595 6.968-15.563 15.563-15.563zm0 2.223c-7.367 0-13.34 5.973-13.34 13.34s5.973 13.339 13.34 13.339c3.538 0 6.93-1.405 9.432-3.907 2.502-2.502 3.907-5.894 3.907-9.432 0-7.367-5.972-13.34-13.34-13.34zm1.111 11.117v11.116h-2.223v-8.893h-2.223v-2.224h4.446zm-1.111-6.67c1.228 0 2.223.995 2.223 2.223 0 1.228-.995 2.223-2.223 2.223-1.228 0-2.224-.995-2.224-2.223 0-1.228.996-2.223 2.224-2.223z",
  transform: "translate(-315 -577) translate(315 577)"
}))));

var SvgNote = function SvgNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note.41b8647c.svg";
export { ForwardRef as ReactComponent };